<template>
  <v-layout mt-5 pt-5 row justify-center align-center>
    <v-flex xs10 md8 lg8>
      <!-- <v-img
        :src="`${appUrl}/storage/img/columbussvg.svg`"
        contain
        ></v-img> -->
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'home-view',
  metaInfo () {
    return { title: this.$t('home') }
  },
  data() {
    return {
      appUrl: window.config.appUrl
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/home.vue